/**
 * Temporary in-memory storage for claim document files.
 * File blobs cannot be stored in Redux (they get serialized and lost),
 * so we store them here for Vista API submission.
 *
 * This storage is cleared when:
 * - Claim is successfully submitted
 * - User navigates away from the claim flow
 * - Browser is refreshed/closed
 */

// Map to store files by their unique key
const claimFilesMap = new Map();

/**
 * Store a file blob with its unique key
 * @param {string} key - Unique identifier for the file (usually file._key)
 * @param {File} file - The File blob to store
 */
export const storeClaimFile = (key, file) => {
  console.log(`[ClaimFilesStorage] storeClaimFile called with key: ${key}, file:`, file);
  console.log(`[ClaimFilesStorage] file instanceof File: ${file instanceof File}`);
  if (key && file instanceof File) {
    claimFilesMap.set(key, file);
    console.log(`[ClaimFilesStorage] Stored file: ${key}, total files: ${claimFilesMap.size}`);
  } else {
    console.warn(`[ClaimFilesStorage] Failed to store file - key: ${key}, isFile: ${file instanceof File}`);
  }
};

/**
 * Get a file blob by its key
 * @param {string} key - Unique identifier for the file
 * @returns {File|undefined} - The File blob or undefined
 */
export const getClaimFile = (key) => {
  return claimFilesMap.get(key);
};

/**
 * Get all stored file blobs
 * @returns {File[]} - Array of all stored File blobs
 */
export const getAllClaimFiles = () => {
  const files = Array.from(claimFilesMap.values());
  console.log(`[ClaimFilesStorage] getAllClaimFiles returning ${files.length} files:`, files);
  return files;
};

/**
 * Remove a file blob by its key
 * @param {string} key - Unique identifier for the file
 */
export const removeClaimFile = (key) => {
  claimFilesMap.delete(key);
  console.log(`[ClaimFilesStorage] Removed file: ${key}, total files: ${claimFilesMap.size}`);
};

/**
 * Clear all stored file blobs
 */
export const clearAllClaimFiles = () => {
  const count = claimFilesMap.size;
  claimFilesMap.clear();
  console.log(`[ClaimFilesStorage] Cleared all files (${count} files removed)`);
};

/**
 * Get the count of stored files
 * @returns {number} - Number of stored files
 */
export const getClaimFilesCount = () => {
  return claimFilesMap.size;
};
